import { render, staticRenderFns } from "./SIconButton.vue?vue&type=template&id=2ff924f7&scoped=true&"
import script from "./SIconButton.vue?vue&type=script&lang=js&"
export * from "./SIconButton.vue?vue&type=script&lang=js&"
import style0 from "./SIconButton.vue?vue&type=style&index=0&id=2ff924f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff924f7",
  null
  
)

export default component.exports